import React from 'react';
import PropTypes from 'prop-types';
const find = require('lodash/find');
const orderBy = require('lodash/orderBy');
const filter = require('lodash/filter');
const values = require('lodash/values');

const KeyboardUtil = require("../../../util/keyboard");
import { ExpandableItem, RadioItem } from './TreeItems.js';

const propTypes = {
    id: PropTypes.string.isRequired,
    className: PropTypes.string,
    selectedProjectId: PropTypes.number,
    channels: PropTypes.array.isRequired,
    projects: PropTypes.array.isRequired,
    folders: PropTypes.object.isRequired,
    foldersFlat: PropTypes.object.isRequired,
    onSelect: PropTypes.func,
};

const defaultProps = {
    className: '',
    selectedProjectId: null,
    onSelect: null,
};

class ChannelProjectFolderTree extends React.Component {
    constructor(props) {
        super(props);
        this._createExpandedObjs = this._createExpandedObjs.bind(this);
        const expandedObj = this._createExpandedObjs({}, {}, props.selectedProjectId, true);
        this.state = {
            expandedChannels: expandedObj.expandedChannelsObj,
            expandedFolders: expandedObj.expandedFoldersObj,
        }
        this._toggleExpanable = this._toggleExpanable.bind(this);
        this._setExpandedExpandable = this._setExpandedExpandable.bind(this);
        this._makeSelection = this._makeSelection.bind(this);
        this.onSelectableClick = this.onSelectableClick.bind(this);
        this.onSelectableKeyDown = this.onSelectableKeyDown.bind(this);
        this.onExpandableClick = this.onExpandableClick.bind(this);
        this.onExpandableKeyDown = this.onExpandableKeyDown.bind(this);
        this.stopPropagation = this.stopPropagation.bind(this);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.selectedProjectId === this.props.selectedProjectId) return;
        const expandedObj = this._createExpandedObjs(this.state.expandedChannels, this.state.expandedFolders, nextProps.selectedProjectId);
        this.setState({ expandedChannels: expandedObj.expandedChannelsObj, expandedFolders: expandedObj.expandedFoldersObj });
    }

    // expandToSelected ensures that the expandable containing the selected selectable shows as expanded. currently only used in constructor.
    _createExpandedObjs(baseChannelObj, baseFolderObj, selectedProjectId, expandToSelected) {
        let expandedChannelsObj = { ...baseChannelObj };
        let expandedFoldersObj = { ...baseFolderObj };
        if (expandToSelected && !!selectedProjectId) {
            const selectedProject = find(this.props.projects, { id: selectedProjectId });
            if (!!selectedProject) {
                expandedChannelsObj[selectedProject.channelId] = true;
                const selectedProjectFolder = !!this.props.foldersFlat[selectedProject.channelId] ? this.props.foldersFlat[selectedProject.channelId][selectedProject.folder_id] : null;
                if (selectedProjectFolder) {
                    expandedFoldersObj[selectedProjectFolder.id] = true;
                    if (!!selectedProjectFolder.parent_id) expandedFoldersObj[selectedProjectFolder.parent_id] = true;
                    if (!!selectedProjectFolder.gp_id) expandedFoldersObj[selectedProjectFolder.gp_id] = true;
                }
            }      
            else {
                console.warn(`ChannelProjectFolderTree: Cannot find project object in props.projects for ID ${selectedProjectId}`);
            }      
        }

        return { expandedChannelsObj: expandedChannelsObj, expandedFoldersObj: expandedFoldersObj };
    }

    _toggleExpanable(type, id) {
        if (type === 'channel') {
            this.setState({
                expandedChannels:  { ...this.state.expandedChannels, [id]: !this.state.expandedChannels[id] }
            });
        }
        else if (type === 'folder') {
            this.setState({
                expandedFolders: { ...this.state.expandedFolders, [id]: !this.state.expandedFolders[id] }
            });
        }
    }

    _setExpandedExpandable(type, id, state) {
        if (type === 'channel') {
            if (this.state.expandedChannels[id] === state) {
                return;
            }

            this.setState({
                expandedChannels: { ...this.state.expandedChannels, [id]: state }
            });
        }
        else if (type === 'folder') {
            if (this.state.expandedFolders[id] === state) {
                return;
            }

            this.setState({
                expandedFolders: { ...this.state.expandedFolders, [id]: state }
            });
        }
    }

    _makeSelection(projectId, channelId) {
        if (!this.props.onSelect) {
            return;
        }

        this.props.onSelect(projectId, channelId);
    }

    onSelectableClick(projectId, channelId, e) {
        e.stopPropagation();
        this._makeSelection(projectId, channelId);
    }

    onSelectableKeyDown(projectId, channelId, e) {
        e.stopPropagation();

        if (KeyboardUtil.isSelectKey(e.keyCode)) {
            e.preventDefault(); //stop spacebar from scrolling
            this._makeSelection(projectId, channelId);
        }
    }

    onExpandableClick(type, id, e) {
        this._toggleExpanable(type, id);
    }

    onExpandableKeyDown(type, id, e) {
        if (KeyboardUtil.isSelectKey(e.keyCode)) {
            e.preventDefault(); //stop spacebar from scrolling
            this._toggleExpanable(type, id);
        }
        else if (KeyboardUtil.isRightArrow(e.keyCode)) {
            this._setExpandedExpandable(type, id, true);
        }
        else if (KeyboardUtil.isLeftArrow(e.keyCode)) {
            this._setExpandedExpandable(type, id, false);
        }
    }

    stopPropagation(e) {
        e.stopPropagation();
    }

    render() {
        const _channels = orderBy(this.props.channels, [channel => channel.name.toLowerCase()], ['asc']);
        const _projects = orderBy(this.props.projects, [project => project.name.toLowerCase()], ['asc']);
        return (
            <ul
                className={this.props.className ? "exp-tree " + this.props.className : "exp-tree"}
                role="radiogroup"
                id={this.props.id}
            >
                {_channels.map((channel) => {
                    const channelRootProjects = [];
                    const channelFolderProjects = {};
                    const sortedChannelFolders = orderBy(this.props.folders[channel.id] || [], [folder => folder.name.toLowerCase()], ['asc']);
                    let depth = 1;
                    _projects.forEach((project) => {
                        if (project.channelId === channel.id) {
                            if (!project.folder_id) {
                                channelRootProjects.push(project);
                            }
                            else {
                                if (!channelFolderProjects[project.folder_id]) channelFolderProjects[project.folder_id] = [];
                                channelFolderProjects[project.folder_id].push(project);
                            }
                        }
                    });
                    return (
                        <li key={`c-${channel.id}`} className="exp-li">
                            <ExpandableItem
                                disabled={channelRootProjects.length === 0 && sortedChannelFolders.length === 0}
                                expanded={this.state.expandedChannels[channel.id] || false}
                                onClick={this.onExpandableClick.bind(this, 'channel', channel.id)}
                                onKeyDown={this.onExpandableKeyDown.bind(this, 'channel', channel.id)}
                                label={channel.name}
                                labelId={`exp-ch-${channel.id}`}
                            />

                            {/* onClick & onKeyDown stopPropagation handlers prevent clicks getting through 'ui holes' from bubbling up to expandable handler */}
                            <ul
                                className={`exp-selectable-list exp-l${depth}`}
                                onClick={this.stopPropagation}
                                onKeyDown={this.stopPropagation}
                                style={this.state.expandedChannels[channel.id] ? {}: { display: "none" }}
                            >
                                {sortedChannelFolders.map((channelFolder) => 
                                    <FolderProjectList
                                        key={`f-${channelFolder.id}`}
                                        channelId={channel.id}
                                        folder={channelFolder}
                                        selectedProjectId={this.props.selectedProjectId}
                                        channelFolderProjects={channelFolderProjects}
                                        expandedChannels={this.state.expandedChannels}
                                        expandedFolders={this.state.expandedFolders}
                                        onExpandableClick={this.onExpandableClick}
                                        onExpandableKeyDown={this.onExpandableKeyDown}
                                        onSelectableClick={this.onSelectableClick}
                                        onSelectableKeyDown={this.onSelectableKeyDown}
                                        depth={depth}
                                    />
                                )}
                                {channelRootProjects.map((project) =>
                                    <li key={`p-${project.id}`} className="exp-li">
                                        <RadioItem
                                            checked={!!this.props.selectedProjectId && this.props.selectedProjectId === project.id}
                                            onClick={this.onSelectableClick.bind(this, project.id, channel.id)}
                                            onKeyDown={this.onSelectableKeyDown.bind(this, project.id, channel.id)}
                                            labelIconClass="fa fa-lightbulb-o"
                                            labelId={`p-radio-${project.id}`}
                                        >
                                            {project.name}
                                        </RadioItem>
                                    </li>
                                )}
                            </ul>
                        </li>
                    )
                })}
            </ul>
        );
    }
}

ChannelProjectFolderTree.propTypes = propTypes;
ChannelProjectFolderTree.defaultProps = defaultProps;

export default ChannelProjectFolderTree;

function FolderProjectList(props) {
    function stopPropagation(e) { e.stopPropagation }

    const projectsInFolder = props.channelFolderProjects[props.folder.id] || [];
    const childFolders = orderBy(values(props.folder.children || {}), [folder => folder.name.toLowerCase()], ['asc']);

    return (
        <li /*key={props.folder.id}*/ className="exp-li">
            <ExpandableItem
                disabled={childFolders.length === 0 && projectsInFolder.length === 0}
                expanded={props.expandedFolders[props.folder.id] || false}
                onClick={props.onExpandableClick.bind(null, 'folder', props.folder.id)}
                onKeyDown={props.onExpandableKeyDown.bind(null, 'folder', props.folder.id)}
                labelIconClass="fa fa-folder"
                label={props.folder.name}
                labelId={`exp-fo-${props.folder.id}`}
            />

            {/* onClick & onKeyDown stopPropagation handlers prevent clicks getting through 'ui holes' from bubbling up to expandable handler */}
            <ul
                className={`exp-selectable-list exp-l${props.depth}`}
                onClick={stopPropagation}
                onKeyDown={stopPropagation}
                style={props.expandedFolders[props.folder.id] ? {}: { display: "none" }}
            >
                {childFolders.map((childFolder) => 
                    <FolderProjectList key={`fp-${childFolder.id}`} {...props} folder={childFolder} depth={props.depth+1} />
                )}
                {projectsInFolder.map((project) =>
                    <li key={`p-${project.id}`} className="exp-li">
                        <RadioItem
                            checked={!!props.selectedProjectId && props.selectedProjectId === project.id}
                            onClick={props.onSelectableClick.bind(null, project.id, props.channelId)}
                            onKeyDown={props.onSelectableKeyDown.bind(null, project.id, props.channelId)}
                            labelIconClass="fa fa-lightbulb-o"
                            labelId={`p-radio-${project.id}`}
                        >
                            {project.name}
                        </RadioItem>
                    </li>
                )}
            </ul>
        </li>
    );
}

FolderProjectList.propTypes = {
    folder: PropTypes.object.isRequired,
    channelId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    selectedProjectId: PropTypes.number,
    channelFolderProjects: PropTypes.object.isRequired,
    expandedChannels: PropTypes.object.isRequired,
    expandedFolders: PropTypes.object.isRequired,
    onExpandableClick: PropTypes.func.isRequired,
    onExpandableKeyDown: PropTypes.func.isRequired,
    onSelectableClick: PropTypes.func.isRequired,
    onSelectableKeyDown: PropTypes.func.isRequired,
    depth: PropTypes.number.isRequired,
    
};

FolderProjectList.defaultProps = {
    selectedProjectId: null,
};